export default __webpack_public_path__ + "static/media/empty.99a53d4d.svg";